import styled from "@emotion/styled";

// 选择账号
export const OAuthListWrapper = styled.div(({ theme: { designTokens: DT } }) => {
    return `
        width: 100%;
        margin-top: 20px;
        .divider-line {
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            &::after, &::before {
                width: 50%;
                height: 1px;
                content: '';
                background-color: ${DT.T_FRAME_SIDEBAR_COLOR_BG_DEFAULT};
            }
        }
        .oauth-login-btn {
            width: 100%;
            height: 48px;
            line-height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${DT.T_COLOR_BG_DEFAULT_DARK};
            border-radius: 4px;
            color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
            cursor: pointer;
            transition: all 0.3s ease;
            .btn-logo {
                font-size: 32px;
            }
            .btn-text {
                margin-left: 16px;
                font-size: 14px;
                color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
            }
            :hover {
                background: #EAEEFD;
            }
        }
    `;
});

export const LoginTitleVLine = styled.div(({ theme: { designTokens: DT } }) => {
    return `
        display: flex;
        align-items: center;
        font-size: 20px;
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
        font-weight: 600;
        &::before {
            width: 3px;
            height: 24px;
            display: inline-block;
            border-radius: 2px;
            margin-right: 12px;
            background-color: ${DT.T_COLOR_LINE_PRIMARY_DEFAULT};
            content: "";
        }
    `;
});



// WEBPACK FOOTER //
// src/pc/components/ThirdPartyOAuth/style.jsx